import { render, staticRenderFns } from "./ServiceNotification.vue?vue&type=template&id=05b4f90c&scoped=true&lang=pug"
import script from "./ServiceNotification.vue?vue&type=script&lang=ts"
export * from "./ServiceNotification.vue?vue&type=script&lang=ts"
import style0 from "./ServiceNotification.vue?vue&type=style&index=0&id=05b4f90c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4f90c",
  null
  
)

/* custom blocks */
import block0 from "./ServiceNotification.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FComponents%2FNotification%2FServiceNotification.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports